<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      title="添加内容"
      width="1200px"
      @close="closeDialog"
    >
      <el-form
        :model="content"
        ref="contentForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="内容类型：" prop="type">
          <el-select v-model="content.type" placeholder="请选择">
            <el-option
              v-for="item in contentTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语言类型：" prop="language">
          <el-select v-model="content.language" placeholder="请选择">
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容：" prop="text">
          <editor v-model="content.text" class="editor"></editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('contentForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisible: false,
      content: {},
      rules: {
        type: [{ required: true, message: '内容类型不能为空！' }],
        language: [{ required: true, message: '语言类型不能为空！' }],
        text: [{ required: true, message: '内容不能为空！' }]
      }
    };
  },
  components: {
    Editor
  },
  computed: {
    ...mapState('contentSetting', ['languageList', 'contentTypeList'])
  },
  methods: {
    ...mapActions('contentSetting', ['create', 'list']),
    closeDialog() {
      this.$refs['contentForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create(this.content).then(() => {
            this.$message.success('添加成功！');
            this.dialogVisible = false;
            this.list();
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor {
  height: 500px;
}
</style>
